module.exports = __webpack_public_path__ + "img/3.093d3e2.svg";